import 'styles/default.less';
import Select from './Select2';



// WEBPACK FOOTER //
// ./src/index.js